import { createIconComponent } from '../../factory/create-icon-component';
export const NorwayIcon = createIconComponent(
  'NorwayIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28273)">
      <path d="M23 5.00031H1V20.0001H23V5.00031Z" fill="#D80027" />
      <path
        d="M23 14.2526H9.68807V19.9998H8.8913H7.05765H6.26088V14.2526H1V13.4373V11.5625V10.7471H6.26088V5H7.05765H8.8913H9.68807V10.7471H23V11.5625V13.4373V14.2526Z"
        fill="#F0F0F0"
      />
      <path
        d="M23 11.5625V13.4373H8.8913V19.9998H7.05765V13.4373H1V11.5625H7.05765V5H8.8913V11.5625H23Z"
        fill="#2E52B2"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28273">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
